import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { sanitizeUri } from "./urlHelper";

export function navigateTo(url: string, openInNewWindow: boolean = false) {
	if (openInNewWindow) {
		windowFactory.open(url);
	} else {
		navigateWindowTo(url, window);
	}
}

export function navigateWindowTo(url: string, window: Window): void {
	window.location.href = sanitizeUri(url);
}

export function navigateRelativeToEnvironment(
	relativeUrl: string,
	openInNewWindow: boolean = false
): void {
	navigateTo(
		createUrlRelativeToEnvironment(relativeUrl),
		openInNewWindow
	);
}

export function navigateToUriInPopOutWindow(uri: string): void {
	const expectedTaskBarSize = 60;
	const width: number = window.screen.availWidth;
	const height: number = window.screen.availHeight - expectedTaskBarSize;
	const params: string = "width=" + width
		+ ", height=" + height
		+ ", top=0, left=0"
		+ ", fullscreen=yes"
		+ ", directories=no"
		+ ", location=no"
		+ ", menubar=no"
		+ ", resizable=no"
		+ ", scrollbars=no"
		+ ", status=no"
		+ ", toolbar=no";

	const target = "_blank";
	windowFactory.open(uri, target, params);
}

export function getRelativeEnvironmentUrl(): string {
	return "/" + getEnvironmentName();
}

export function getEnvironmentName(): string {
	// e.g. pathname '/{environment}/Documents'
	return window.location.pathname.split("/")[1];
}

export function createUrlRelativeToEnvironment(relativeUrl: string): string {
	if (relativeUrl !== ""
		&& relativeUrl[0] !== "/"
	) {
		relativeUrl = "/" + relativeUrl;
	}

	return getEnvironmentUrl() + relativeUrl;
}

export function reloadCurrentPage(): void {
	window.location.reload();
}

export function getEnvironmentUrl(): string {
	return window.location.protocol + "//" + window.location.host + getRelativeEnvironmentUrl();
}
